export default {
  Filter: {
    User: 'User',
    Event: 'Event',
  },
};
